/* @flow */
import React from 'react';
import classnames from 'classnames/bind';

import s from './SessionExpiryWarning.styl';
const cx = classnames.bind(s);

type SessionExpiryWarningProps = {
  removeTimeoutWarning: Function,
};

export class SessionExpiryWarning extends React.Component {
  props: SessionExpiryWarningProps;

  render() {
    const { removeTimeoutWarning } = this.props;
    return (
      <div
        className={cx('SessionExpiryWarning')}
        onClick={removeTimeoutWarning}>
        <div className={cx('inner')}>
          <div className={cx('warning')}>
            <strong>WARNING:</strong> Session expiring soon
          </div>
          <p>You will be logged out soon and <strong>any unsaved work will be lost</strong>. Click anywhere to remain logged in.</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/SessionExpiryWarning.js